import { Outlet, createFileRoute } from '@tanstack/react-router'
import { HeaderComponent } from '@/components/layout/header'
import { FooterComponent } from '@/components/layout/footer'
import { SideNavComponent } from '@/components/layout/sideNav'
import { SidebarProvider } from '@/components/ui/sidebar'
export const Route = createFileRoute('/layout/frame')({
  component: LayoutComponent,
})

function LayoutComponent() {
  return (
    <SidebarProvider>
        {/* <SideNavComponent /> */}
        <div className="w-full min-h-screen">
          <HeaderComponent />
          <SideNavComponent />
          <div className='min-h-screen'>
            {/* <SideNavComponent /> */}
            <Outlet />
          </div>
          <FooterComponent />
        </div>
    </SidebarProvider>
  )
}